// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1J-vE","requiredAsterisk":"Info_requiredAsterisk__1mCy4"};